import React, { useEffect, useState } from 'react';
import {Radar} from 'react-chartjs-2';
import {API_URL} from "./App";

import {
  ArcElement,
  Chart as ChartJS,
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Title,
  Tooltip,
  Legend,
  RadialLinearScale
} from 'chart.js';

ChartJS.register(
  ArcElement,
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Title,
  Tooltip,
  Legend,
  RadialLinearScale
);

const CardDistributionChart = () => {
  const [dates, setDates] = useState([]);
  const [selectedDate, setSelectedDate] = useState('');
  const [chartData, setChartData] = useState(null);

  // Load dates
  useEffect(() => {
    fetch(API_URL + "/statistics/available-dates")
      .then(res => res.json())
      .then(data => {
        setDates(data);
        setSelectedDate(data[0]); // default to most recent
      });
  }, []);

  useEffect(() => {
    fetch(API_URL + `/statistics/card-distribution?date=${selectedDate}`)
      .then((res) => res.json())
      .then((data) => {
        setChartData({
          labels: data.labels,
          datasets: data.datasets
        });
      });
  }, [selectedDate]);

  const options = {
    responsive: true,
    fill: true,
    borderWidth: 8,
    borderColor: "#000000",
    scales: {
      r: {
        angleLines: {
          display: false,
        },
        grid: {
          color: '#c2aecf40',          // dunkle Farbe
          lineWidth: 2            // fetter
        },
        //suggestedMin: 15,
        //suggestedMax: 40,
        ticks: {
          font: {
            size: 16,
          },
        },
        pointLabels: {
          font: {
            size: 22,
            weight: 'bold',
          },
        },
      },
    },
    plugins: {
      legend: {
        position: 'top',
        labels: {
          font: {
            size: 20,
            weight: 'bold',
          },
        },
      },
      title: {
        display: true,
        text: 'Ober/Unter Distribution pro Spieler',
        font: { size: 16 },
      },
    },
  };

  return chartData ? <div> <h2>Kartenverteilung der Spiele</h2>
      <label htmlFor="date">Filterdatum: </label>
      <select id="date" value={selectedDate} onChange={e => setSelectedDate(e.target.value)}>
        {dates.map(date => (
          <option key={date} value={date}>{date}</option>
        ))}
          <option value="" >Alle Daten</option>
      </select> <div className={"Radar"}><Radar data={chartData} options={options} /> </div></div>: <p>Loading chart...</p>;
};

export default CardDistributionChart;